export default {
    AgendaDeliberacao: axios.create({
        baseURL: process.env.VUE_APP_ENDPOINT_API + "agenda-deliberacao"
    })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/AgendaDeliberacao.js
// module id = FRMh
// module chunks = 32